import { Button, CircularProgress, Dialog, DialogContent } from '@mui/material'
import React from 'react'

export default function ConfirmDialogReserve({ open, setOpen, rows, handleAdd, reserveType, branchs, loadingsubmit }) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                            รายการสำรองเมล็ดพันธุ์ {/* {{data?.header}} */}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-borderless  ">
                            <thead>
                                <tr>
                                    <th scope="col " class="text-center">ที่</th>
                                    <th scope="col " class="text-center">ชื่อเมล็ดพันธุ์</th>
                                    <th scope="col " class="text-center">ชั้นพันธุ์</th>
                                    <th scope="col " class="text-center">ฤดู</th>
                                    <th scope="col " class="text-center">ปี</th>
                                    <th scope="col " class="text-center">กลุ่มพันธุ์ </th>
                                    <th scope="col " class="text-center">สารเคมี </th>
                                    <th scope="col " class="text-center">จังหวัด</th>
                                    <th scope="col " class="text-center">อำเภอ</th>
                                    <th scope="col " class="text-center">ตำบล</th>
                                    <th scope="col " class="text-center">จำนวน</th>
                                    <th scope="col " class="text-center">หน่วย</th>
                                    <th scope="col " class="text-center">ราคา/หน่วย</th>
                                    <th scope="col " class="text-center">ราคารวม</th>
                                    <th scope="col " class="text-center">ค่าขนส่ง</th>
                                    {reserveType === 'center' && <th scope="col " >ศูนย์</th>}
                                    <th scope="col " class="text-center">วันที่รับ</th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {rows?.filter((x) => x?.ItemNo?.ItemName).map((creds, i) => (

                                    <tr >
                                        <td>{i + 1}.</td>
                                        <td class="text-center">
                                            {creds?.ItemNo?.ItemName}
                                        </td>
                                        <td class="text-center">{creds?.ItemNo?.Option2}</td>
                                        <td class="text-center"> <span style={{ fontWeight: "bold", color: creds?.Season === 'ฝน' ? '#0D9206' : 'brown' }}>{creds?.ItemNo?.Season}
                                        </span></td>
                                        <td class="text-center">{creds?.Year}</td>
                                        <td class="text-center">{creds?.ItemNo?.Option1}</td>
                                        <td class="text-center">{creds?.ItemNo?.Chemical}</td>
                                        <td class="text-center">
                                            {creds?.Province}
                                        </td>
                                        <td class="text-center">

                                            {creds?.District}
                                        </td>
                                        <td class="text-center">
                                            {creds?.SubDistrict}
                                        </td>
                                        <td class="text-center"> {creds?.Qty}</td>
                                        <td class="text-center">{creds?.ItemNo?.UnitNo?.UnitName || creds?.UnitNo?.UnitName}</td>
                                        <td class="text-center">{parseFloat(creds?.ItemNo?.SalePrice).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                        <td class="text-center">
                                            {parseFloat(creds?.ItemNo?.SalePrice * +(creds?.Qty.toString().replaceAll(',', '')) || 0).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                        </td>
                                        <td class="text-center">{parseFloat(creds?.Freight).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                        {reserveType === 'center' && <td class="text-center">
                                            {branchs?.find((b) => b?.BranchNo === creds?.BranchNo)?.BranchName}
                                        </td>}
                                        <td class="text-center">
                                            {creds?.DueDate}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div >


                </div >
                <div class="row mt-4">

                    <div class="col-12 text-end">
                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button disabled={loadingsubmit} onClick={() => handleAdd('Y')} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>{loadingsubmit ? <CircularProgress size={'24px'} color="inherit" /> : 'ยืนยันการทำรายการ'}</Button>

                    </div>
                </div>
            </DialogContent >
        </Dialog >
    )
}
